var plugin_rtlignore_default = {
  "alignLeft": "eK2xv",
  "textWrapNowrap": "FQ-xP",
  "alignRight": "WchXy",
  "alignCenter": "_7T4Uc",
  "sizeFullWidth": "_5VNx9",
  "renderedInTable": "yvoVs",
  "sizeOriginal": "ytibG",
  "sizeContent": "LIugr",
  "sizeSmall": "SkJEB",
  "sizeSmallCenter": "WDh7n",
  "flex": "XeRKC",
  "atomic": "KqKMh",
  "embed": "hP1pj",
  "horizontalScrollbar": "uigjb",
  "pluginContainerMobile": "_3T439"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
